import { FilterChoice } from '../../../common/components/SearchHeader/types/FilterChoice';
import { renderLocationChoice } from '../../../common/components/SearchHeader/types/LocationChoice';
import { SidebarLinkSection } from '../../ResultView/Sidebar/SidebarLinkSection/SidebarLinkSection';
import { composeFilters } from '../../page-seo/composeFilters';
import { makeLinkSpec } from '../../page-seo/makeLinkSpec';
import { LinkSection } from '../LinkSection/LinkSection';
import { makeSpecialtyPreset } from './helpers';

interface Props {
  filters: FilterChoice;
  isSidebar?: boolean;
}

export const SpecialistPresetLinks = ({ filters, isSidebar = false }: Props) => {
  const commonLinkSectionProps = {
    title: `Find specialists in ${renderLocationChoice(filters.location)}`,
    links: getLinksBySpecialty(filters.topic?.specialist).map(preset =>
      makeLinkSpec(composeFilters(filters, preset.filters), preset.title),
    ),
  };

  const linkSection = isSidebar ? (
    <SidebarLinkSection {...commonLinkSectionProps} />
  ) : (
    <LinkSection {...commonLinkSectionProps} />
  );

  return !filters.onlineAppointments ? linkSection : null;
};

const getLinksBySpecialty = (specialtyName?: string) => {
  if (specialtyName === 'Dentist')
    return [
      makeSpecialtyPreset('Paediatric Dentist'),
      makeSpecialtyPreset('Orthodontist'),
      makeSpecialtyPreset('Endodontist'),
      makeSpecialtyPreset('Periodontist'),
      makeSpecialtyPreset('Oral Surgeon'),
      makeSpecialtyPreset('Prosthodontist'),
      makeSpecialtyPreset('Dental Hygienist'),
      makeSpecialtyPreset('Dental Therapist'),
      makeSpecialtyPreset('Maxillofacial Surgeon'),
    ];

  return [];
};
